import { makeStyles, darken } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      height: 66,
      justifyContent: 'start',
      backgroundColor: COLORS.neutral.darkGray,
      border: `1px solid ${COLORS.neutral.mediumGray}`,
      borderRadius: theme.shape.borderRadiusSmall,
      padding: theme.spacing(1.5),

      '&:hover': {
        backgroundColor: darken(COLORS.neutral.darkGray, 0.2),
      },
    },
    content: {
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'start',
    },
    row: {
      display: 'flex',
      alignItems: 'center',

      '& + &': {
        marginTop: theme.spacing(1),
      },
      '& > * + *': {
        marginLeft: theme.spacing(0.5),
      },
    },
    badgeBeta: {
      padding: theme.spacing(0, 0.5),
      backgroundColor: COLORS.success.light,
      borderRadius: theme.shape.borderRadiusMinimal,

      fontSize: theme.typography.pxToRem(11),
      lineHeight: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightSemiBold,
      color: COLORS.success.active,
    },
    badgeExtension: {
      padding: theme.spacing(0, 0.5),
      backgroundColor: '#F4EDFE',
      borderRadius: theme.shape.borderRadiusMinimal,

      fontSize: theme.typography.pxToRem(11),
      lineHeight: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightSemiBold,
      color: '#9340FF',
    },
    icon: {
      fontSize: theme.typography.pxToRem(16),
      color: COLORS.neutral.white,
    },
    text: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightSemiBold,
      color: COLORS.neutral.white,
      whiteSpace: 'nowrap',
    },
  }),
  { name: 'ButtonExtension' }
);
